<template>
  <div>
    <input v-if="isActive" :value="product.master.id" type="hidden" name="variants[][id]" />
    <input v-if="isActive" :value="currentAmount" type="hidden" name="variants[][quantity]" />

    <div class="bg-white p-2 shadow-sm">
      <div class="row justify-content-between align-items-center">
        <div class="col-md-12 mb-2 mb-md-0">
          {{ product.name }}
        </div>
        <div class="col-md-12 d-flex flex-wrap justify-content-between justify-content-md-end">
          <div class="mb-md-2 text-right text-xl-left d-flex align-items-center">
            <div class="text-nowrap h6 mb-0 mr-2">
              <span v-if="isActive">{{ currentAmount }} &times;</span>
              {{ product.master.price | toCurrency }}&nbsp;€
            </div>
          </div>
          <div class="mb-md-2 d-flex align-items-center justify-content-end">
            <button
              v-if="isActive"
              @click="decreaseAmount"
              type="button"
              class="btn btn-outline-primary px-3 mr-2"
            >
              -
            </button>
            <button @click="increaseAmount" type="button" class="btn btn-outline-primary px-3">
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TicketStoreItem",
  filters: {
    toCurrency(value) {
      value = parseFloat(value);
      return `${value.toFixed(2)}`.replace(".", ",");
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedProducts: "eventShow/selectedProducts",
    }),
    currentAmount() {
      const product = this.selectedProducts.find(p => p.id === this.product.master.id);
      return product ? product.amount : 0;
    },
    isActive() {
      return this.currentAmount > 0;
    },
  },
  methods: {
    ...mapActions({
      changeProductAmountBy: "eventShow/changeProductAmountBy",
    }),
    increaseAmount() {
      this.changeProductAmountBy({ amount: 1, productId: this.product.master.id });
    },
    decreaseAmount() {
      if (this.currentAmount > 0) {
        this.changeProductAmountBy({ amount: -1, productId: this.product.master.id });
      }
    },
  },
};
</script>
